export const APP_VERSION = {
  version: '1.1.5',
  buildDate: '2026-03-17T10:02:30.981Z',
  commitHash: 'N/A'
};
